import React from "react";
import { FilterChip, GLYPH } from "./v2";
import { CLUB_STATUS_FILTERS, FROM_SCOUT_REQUESTS_FILTER } from "../../constants/clubRadarChoices";

// Filter chip row (frames 1a desktop / 1e mobile — V2 rebuild): All · Watching ·
// Recommended · Rejected · Shortlisted · From scout requests, each with a live
// "· count", plus the Label dropdown styled as a chip. Single active chip (a
// status OR the scout-request origin, R2). The "From scout requests" chip keeps
// its artboard placement (DESIGN-SPEC 1a/1e chip rows) and its existing handler.
// Presentation only — same setFilter/setFilterLabel wiring as before.

// "Label ▾" chip — the platform's native <select> (same options/handler),
// styled as an artboard chip with the ▾ caret overlaid.
const LabelSelectChip = ({ labels, filterLabel, setFilterLabel, mobile }) => {
  const active = filterLabel !== "all";
  return (
    <span style={{ position: "relative", display: "inline-flex" }}>
      <select
        value={filterLabel}
        onChange={(e) => setFilterLabel(e.target.value)}
        className="cursor-pointer outline-none"
        style={{
          borderRadius: 999,
          border: active ? "1px solid #D6E7FF" : "1px solid #E5E7EB",
          background: active ? "#E8F1FF" : "#FFFFFF",
          color: active ? "#1B6FE0" : "#6B7280",
          fontSize: mobile ? 12 : 12.5,
          fontWeight: active ? 700 : 600,
          padding: mobile ? "5px 24px 5px 10px" : "5px 26px 5px 12px",
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
          fontFamily: "inherit",
        }}
      >
        <option value="all">Label</option>
        {labels.map((l) => (
          <option key={l.id} value={l.id}>{l.name}</option>
        ))}
      </select>
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          right: mobile ? 9 : 11,
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: 10,
          color: active ? "#1B6FE0" : "#9CA3AF",
          pointerEvents: "none",
        }}
      >
        {GLYPH.caretDown}
      </span>
    </span>
  );
};

const chipText = (label, count) => (count != null ? `${label} ${GLYPH.middot} ${count}` : label);

const ClubFilterChips = ({ filter, setFilter, counts = {}, labels = [], filterLabel, setFilterLabel, mobile = false, style }) => (
  <div style={{ display: "flex", alignItems: "center", gap: mobile ? 6 : 8, flexWrap: "wrap", ...style }}>
    {CLUB_STATUS_FILTERS.map((f) => (
      <FilterChip
        key={f.value}
        mobile={mobile}
        active={filter === f.value}
        onClick={() => setFilter(f.value)}
      >
        {chipText(f.label, counts[f.value === "all" ? "all" : f.value])}
      </FilterChip>
    ))}
    <FilterChip
      mobile={mobile}
      active={filter === "scout_requests"}
      onClick={() => setFilter("scout_requests")}
    >
      {chipText(FROM_SCOUT_REQUESTS_FILTER.label, counts.scout_requests)}
    </FilterChip>
    <LabelSelectChip labels={labels} filterLabel={filterLabel} setFilterLabel={setFilterLabel} mobile={mobile} />
  </div>
);

export default ClubFilterChips;
